<template>
  <div>
    <div
      v-if="
        checkTokenRegistration != undefined && checkTokenRegistration != null && checkTokenRegistration != ''
      "
      class="admin-page"
    >
      <!-- navigation bar -->
      <div class="navbar">
        <admin-navbar @clearDataToken="clearDataToken" />
      </div>
      <!-- sidebar with servers list -->
      <div class="sidebar-container" :class="{ collapsed: isSidebarCollapsed }">
        <admin-sidebar
          :servers="servers"
          :selected-server="selectedServer"
          :loading="!isServersInit"
          :collapsed.sync="isSidebarCollapsed"
          @serverSelected="switchServer($event.server)"
          @commonSelected="switchServer(null)"
        />
      </div>
      <!-- main information panel -->
      <div class="main">
        <admin-main-panel
          :servers="servers"
          :selected-server="selectedServer"
          :loading="!isServersInit"
          @serverSelected="switchServer($event.server)"
          @updateServerInfoFlag="flagServer = $event"
        />
      </div>

      <!-- Modals manager -->
      <admin-modals-manager
        :flag-server="flagServer"
        @shangeFlagUpdateServer="shangeFlagUpdateServer"
      />
    </div>
    <div v-else class="modalWrapper">
      <div class="wrapper">
        <p class="titleHeader">Login</p>
        <div class="wrapperItems">
          <div class="item">
            <el-input
              v-model="inputLogin"
              class="input"
              placeholder="Login"
            ></el-input>
          </div>
          <div class="item">
            <!-- <p class="textStyle">Пароль</p> -->
            <el-input
              v-model="inputPassword"
              class="input"
              type="password"
              placeholder="Password"
            ></el-input>
          </div>
          <div class="wrapperBtn">
            <!-- <button class="btnCancel btnStyle" @click="closeModal">
              Logout
            </button> -->
            <button class="btnSend btnStyle" @click="enterInAdmin">
              Sign In
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

/** Components */
import AdminNavbar from "@/components/admin/AdminNavbar.vue";
import AdminSidebar from "@/components/admin/AdminSidebar.vue";
import AdminMainPanel from "@/components/admin/main/AdminMainPanel.vue";

import { getAPI, token } from "@/api/params.js";
import {
  getTokenAdmin,
  getWorkerScaling,
  checkToken,
  logout
} from "@/api/auth.js";
/** Modals manager */
import AdminModalsManager from "@/components/admin/modals/AdminModalsManager.vue";

// @group Admin Page
// Servers management page
export default {
  name: "AdminPage",
  components: {
    AdminNavbar,
    AdminSidebar,
    AdminMainPanel,
    /** modals manager */
    AdminModalsManager
  },
  props: {
    serverId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      /** servers initialized flag */
      isServersInit: false,
      isSidebarCollapsed: true,
      flagServer: null,
      inputLogin: "",
      inputPassword: "",
      tokenAdmin: {},
      // tokenAdminDefoult: ""
    };
  },
  computed: {
    ...mapState({
      servers: state => state.admin.servers,
      refreshToken: state=> state.admin.refreshToken,
      /** current selected server ID */
      selectedServerId: state => state.admin.currentServerId
    }),
    // @vuese
    // Selected server object
    selectedServer() {
      if (this.selectedServerId == null) {
        /** check that id is set, otherwise return null */
        return null;
      }
      const server = this.servers.find(s => s.id == this.selectedServerId);
      return server;
    },
    checkTokenRegistration(){
      return this.refreshToken
    },
  },
  watch: {
    // @vuese
    // Init servers
    servers() {
      /** servers initialized */
      this.isServersInit = true;
    }
  },
  async mounted() {
    // this.tokenAdminDefoult = localStorage.getItem("accessToken");

    this.initServers();
    if (this.serverId) {
      this.switchServer({ id: this.serverId });
    }
  },
  methods: {
    ...mapActions("admin", ["initServers", "setCurrentServer"]),
    shangeFlagUpdateServer() {
      this.flagServer = null;
    },
    async enterInAdmin() {

      if (this.inputLogin != "" && this.inputPassword != "") {
        try {
          const getToken = await getTokenAdmin(
            this.inputLogin,
            this.inputPassword
          );
          // this.tokenAdminDefoult = getToken.accessToken;
        } catch (e) {
          this.$message.error(`${e}`);
        }
      } else {
        this.$message.error("Please fill in all fields");
      }
    },
    clearDataToken() {
      this.tokenAdminDefoult = localStorage.getItem("accessToken");
    },
    // async closeModal() {
      // await logout();
      // checkToken()
      // getTokenAdminRefresh()
      // window.close();
      // this.serverId = 3
    // },

    // @vuese
    // Change selected server
    // @arg server - new server object
    switchServer(server) {
      this.setCurrentServer(server);
      if (server !== null) {
        this.$router.push(`/admin/servers/${server.id}`);
      } else {
        this.$router.push("/admin");
      }
      // this.$router.push(`/channels/${newChannel}?token=${token}`);
    }
  }
};
</script>
<style>
.el-input__inner {
  background-color: #c4c4c4 !important;
  border: none;
}
</style>
<style scoped>
.admin-page {
  min-height: 100vh;
}
.wrapperBtn {
  text-align: center;
}
.linkHeader {
  font-size: 14px;
}
.btnStyle {
  width: 240px;
  height: 40px;
  /* margin: 20px 10px 0; */
  border: none;
  border-radius: 7px;
  margin: 10px 0px;
  /* font-family: sans-serif; */
}
.btnCancel {
  color: #1f61da;
}
.btnCancel:hover {
  box-shadow: 0px 0px 10px rgb(70, 70, 70);
  transition: box-shadow 0.5s;
}
.btnSend:hover {
  box-shadow: 0px 0px 10px rgb(70, 70, 70);
  transition: box-shadow 0.5s;
}
.btnSend {
  cursor: pointer;
  background-color: #000000;
  color: #ffffff;
}
.modalWrapper {
  display: flex;
  justify-content: center;
  margin: 20px;
  padding-top: 280px;
}

.wrapper {
  /* border: 1px solid black; */
  padding: 25px;
  /* border-radius: 7px; */
  /* box-shadow: 0px 0 5px #776e6e; */
}

.titleHeader {
  font-size: 24px;
  display: flex;
  justify-content: center;
  /* font-family: sans-serif; */
}

.wrapperItems {
}

.item {
  display: flex;
}

.textStyle {
  font-size: 14px;
  width: 160px;
  font-weight: 100;
  /* font-family: sans-serif; */
}

.el-input {
  /* width: 150px !important; */
  margin: 5px 0;
}

@media only screen and (min-width: 992px) {
  .admin-page {
    display: grid;
    grid-template-rows: 70px auto;
    grid-template-columns: 18% 82%;
  }
  .navbar {
    grid-column-start: 1;
    grid-column-end: end;
  }
}
@media only screen and (max-width: 991px) {
  .navbar {
    position: fixed;
    top: 0;
    width: 100%;
    height: 50px;
    z-index: var(--second-layer);
  }
  .main {
    margin-top: 50px;
    margin-left: 50px;
  }
  .sidebar-container.collapsed {
    left: calc(50px - 100%);
  }
  .sidebar-container {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 50px;
    z-index: var(--second-layer);
    left: 0;
    transition: left 0.5s;
  }
}
</style>

<style>
#app {
  min-height: 100vh;
}

:root {
  /** colors */
  --main-bg-color: white;
  --navbar-bg-color: #070707;
  --navbar-font-color: white;
  --sidebar-bg-color: #c4c4c4;
  --sidebar-sel-font-color: #0820f5;
  --sidebar-sel-bg-color: #a1a1a1;
  --success-color: #3bd422;
  --error-color: #e24311;
  --light-error-color: #ff4a4a;
  /** fonts */
  --sans-font: "Open Sans", sans-serif;
  --big-font-sz: 1.33rem;
  --norm-font-sz: 1rem;
  --small-font-sz: 0.9rem;
  --tiny-font-sz: 0.75rem;
  /** transition */
  --long-transition: 1s;
  --fast-transition: 0.5s;
  /** z-layers */
  --top-layer: 3000;
  --second-layer: 200;
  --first-layer: 100;
}
html {
  font-size: 18px;
}

.title {
  font-family: var(--sans-font);
  font-size: var(--big-font-sz);
  font-weight: bold;
}

.subtitle {
  font-family: var(--sans-font);
  font-weight: bold;
}
</style>
